export default __webpack_public_path__ + "static/media/yuanpan.e08a63af.png";